var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    width: "1em",
    viewBox: "0 0 14 2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2484",
    d: "M0 2V0h14v2Z",
    fill: "currentColor"
  })));
};
export default SvgMinus;